export default async function getActionsRoles() {
  const catalogValues = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.action;
  const actionForThisProfile =
    JSON.parse(localStorage.getItem("profile"))?.actions || [];

  const filteredActionNames = actionForThisProfile.map(
    (actionId) => catalogValues?.[actionId]
  );
  
  return filteredActionNames;
}
